export default class WorkItemExport {
  id: string;

  workItemNumber: number;

  origin: string;

  status: string;

  title: string;

  workItemType: string;

  createdDate: Date;

  originCreatedDate: Date;

  estimatedDeadLine: Date;

  concludedAt: string;

  createdBy: string;

  assignedTo: string;

  originalEstimate: number;

  effortSpent: number;

  originSystem: string;

  delivery?: boolean;

  isAggregator?: boolean;

  parentNumber: number;

  constructor(obj: any) {
    this.id = obj.id;
    this.workItemNumber = obj.workItemNumber;
    this.origin = obj.origin || 'CORE';
    this.status = obj.status;
    this.title = obj.title;
    this.workItemType = obj.workItemType;
    this.createdDate = obj.createdDate;
    this.originCreatedDate = obj.originCreatedDate;
    this.estimatedDeadLine = obj.estimatedDeadLine;
    this.concludedAt = obj.concludedAt || '';
    this.createdBy = obj.createdBy;
    this.assignedTo = obj.assignedTo;
    this.originalEstimate = obj.originalEstimate;
    this.effortSpent = obj.effortSpent || 0;
    this.originSystem = obj.originSystem;
    this.delivery = obj.delivery || false;
    this.isAggregator = obj.isAggregator || false;
    this.parentNumber = obj.parentNumber || null;
  }

  public static of(value: any): WorkItemExport {
    return new WorkItemExport(value || {});
  }

  public static ofList(response: any): WorkItemExport[] {
    return response.map(this.of);
  }

  public get deliveryFormatted(): string {
    return this.delivery ? 'YES' : 'NO';
  }

  public get isAggregatorFormatted(): string {
    return this.isAggregator ? 'YES' : 'NO';
  }
}
